import type { LanguageType } from "./language";

export interface RegisterDetailsModel {
  organizationLegalName: string;
  operatingName: string;
  streetAddress: string;
  unitSuite: string;
  city: string;
  provinceTerritory: string;
  postalCode: string;
  billingContactName: string;
  billingContactTitle: string;
  billingContactPhoneNumber: string;
  billingContactEmail: string;
  confirmEmail: string;
  organizationTypes: string[];
  taxID: string;
  locationOfIncorporation: string;
  hasSuitsLiensJudgements?: boolean;
  suitsLiensJudgementsDescription: string;
  organizationOwnershipName: string;
  organizationOwnershipTitle: string;
  organizationOwnershipPercentage: string;
  organizationOwnershipHomeAddress: string;
  organizationActivities: string[];
  isBuyingOnBehalfOfThirdParty?: boolean;
  thirdPartyName: string;
  isDetailsConfirmed: boolean;
  subscribeToEmailUpdates: boolean;
  language: LanguageType;

  orgActivityOtherDesc: string;
}

export const createDefaultRegisterDetails = (): RegisterDetailsModel => {
  return {
    organizationLegalName: "",
    operatingName: "",
    streetAddress: "",
    unitSuite: "",
    city: "",
    provinceTerritory: "",
    postalCode: "",
    billingContactName: "",
    billingContactTitle: "",
    billingContactPhoneNumber: "",
    billingContactEmail: "",
    confirmEmail: "",
    organizationTypes: [],
    taxID: "",
    locationOfIncorporation: "",
    suitsLiensJudgementsDescription: "",
    organizationOwnershipName: "",
    organizationOwnershipTitle: "",
    organizationOwnershipPercentage: "",
    organizationOwnershipHomeAddress: "",
    organizationActivities: [],
    thirdPartyName: "",
    subscribeToEmailUpdates: false,
    isDetailsConfirmed: false,
    orgActivityOtherDesc: "",
    language: "english",
  };
};

export const getOrgActivities = (data: RegisterDetailsModel): string[] => {
  const otherProp = "Other";
  const desc = data.orgActivityOtherDesc;
  let value = "";

  if (data.organizationActivities.includes(otherProp))
    value = `${otherProp}${desc ? ` - ${desc}` : ""}`;

  return [
    ...data.organizationActivities.filter((t) => t !== otherProp),
    ...(value ? [value] : []),
  ];
};
